import { SemesterServiceInterface } from 'domain/services';
import { GetAllSemestersUserUseCaseInterface } from 'domain/usecases';

export class SemesterService implements SemesterServiceInterface {
  constructor(
    private readonly _getAllSemestersUserUseCase: GetAllSemestersUserUseCaseInterface,
  ) {}

  async getAllSemestersUser(
    params: GetAllSemestersUserUseCaseInterface.Params,
  ): Promise<GetAllSemestersUserUseCaseInterface.Result> {
    return await this._getAllSemestersUserUseCase.execute(params);
  }
}
